import React from 'react';

const stappen = [
  { sub: 'Stap 01', title: 'Opname op locatie', text: 'Samen kijken wat er écht nodig is — niet meer, niet minder.' },
  { sub: 'Stap 02', title: 'Vaste prijs per post', text: 'Heldere offerte. Meerwerk alleen schriftelijk vooraf bevestigd.' },
  { sub: 'Stap 03', title: 'Planning in overleg', text: 'Planning afgestemd met u — minimale overlast.' },
  { sub: 'Stap 04', title: 'Uitvoering & oplevering', text: 'Vakkundig, opgeruimde werkplek, nette oplevering.' },
];

export default function ServiceThree() {
  return (
    <>
      <section className="services-three" id="werkwijze">
        <div className="container">
          <div className="section-title text-center">
            <div className="section-title__tagline-box">
              <span className="section-title__tagline">Werkwijze</span>
            </div>
            <h2 className="section-title__title">
              Vier stappen — <span>geen verrassingen</span>
            </h2>
          </div>
          <div className="services-three__inner">
            <ul className="services-three__service-list list-unstyled">
              {stappen.map((stap, index) => (
                <li key={index}>
                  <div className="services-three__service-list-single">
                    <div className="services-three__sub-title">
                      <p>{stap.sub}</p>
                    </div>
                    <h3 className="services-three__title">{stap.title}</h3>
                    <p className="services-three__step-text">{stap.text}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </>
  );
}
